module.exports = __webpack_public_path__ + "img/touxiang.cfd13c07.png";